import { getItem, removeItem, setItem } from '@core/storage/localStorage'
import { StorageKeyEssentialEnum } from '@core/storage/types'

export const CALL_KEY = StorageKeyEssentialEnum.fw_otocall

/** Persists the call id in local storage. */
export function setCall(id: string) {
  setItem(CALL_KEY, id, new Date(Date.now() + 3600 * 3 * 1000)) // 3 hours
}

/** Removes the persisted call. */
export function removeCall() {
  removeItem(CALL_KEY)
}

/**
 * @returns The call id in local storage. Undefined if no call.
 */
export function getCall() {
  return getItem<string>(CALL_KEY)
}
